import {UiEvent, UiEventType} from '@web/middlewares/uiLogging'

export const resultNClicksMap = new Map<UiEventType, [string, string]>([
    [UiEvent.RESULT_LOGO, ['ctm.paylogo', 'ctm.paylogo']],
    [UiEvent.RESULT_HEADER_CART, ['ctm.gnbcart', 'ctm.gnbcart']],
    [UiEvent.RESULT_HEADER_SHOPPING_HOME, ['ctm.gnbshopping', 'ctm.gnbshopping']],
    [UiEvent.ECOUPON_BARCODE_INFO, ['ctm.barcode', 'ctm.barcode']],
    [UiEvent.VIRTUAL_ACCOUNT_NUMBER, ['ctm.copyaccountnumber', 'ctm.copyaccountnumber']],
    [UiEvent.DELIVERY_CHANGE, ['ctm.change', 'ctm.change']],
    [UiEvent.DELIVERY_MEMO_CHANGE_BUTTON, ['ctm.memoedit', 'ctm.memoedit']],
    [UiEvent.ORDER_LIST, ['ctm.orderlist', 'ctm.orderlist']],
    [UiEvent.ORDER_NO, ['ctm.orderno', 'ctm.orderno']],
    [UiEvent.ORDER_ITEM_OPEN, ['ctm.itemopen', 'ctm.itemopen']],
    [UiEvent.ORDER_ITEM_FOLD, ['ctm.itemfold', 'ctm.itemfold']],
    [UiEvent.ORDER_DETAIL, ['ctm.orderdetail', 'ctm.orderdetail']],
    [UiEvent.TIMELINE, ['ctm.timeline', 'ctm.timeline']],
    [UiEvent.PAY_NOW, ['ctm.pay', 'ctm.pay']],
    [UiEvent.ACCUMULATE_POINT_OPEN_REVIEW_TOOLTIP, ['ctm.revinfo', 'ctm.reviewbenefit']],
    [UiEvent.PRODUCT_NAME, ['ctm.image', 'ctm.product']],
    [UiEvent.PRODUCT_THUMBNAIL, ['ctm.name', 'ctm.product']],
    [UiEvent.SHOPPING_MALL_NAME, ['ctm.shoptext', 'ctm.shoptext']],
    [UiEvent.ORDER_LIST_BUTTON, ['ctm.orderlist', 'ctm.buylst']],
    [UiEvent.SHOPPING_HOME_BUTTON, ['ctm.home', 'ctm.home']],
    [UiEvent.GFD_BANNER_CLOSE, ['ctm.chrgebannerx', 'ctm.chrgebannerx']],
    [UiEvent.GFD_BANNER_WEEK_CLOSE, ['ctm.chrgebanner30x', 'ctm.chrgebanner30x']],
    /** 배송지 관리 */
    [UiEvent.RESULT_ADDRESS_BOOK_BACK_BUTTON, ['ctm.addrback', 'ctm.addrback']],
    [UiEvent.RESULT_ADDRESS_BOOK_ADD_BUTTON, ['ctm.addrnew', 'ctm.addrnew']],
    [UiEvent.RESULT_ADDRESS_BOOK_ADDRESS, ['ctm.addrselect', 'ctm.addrselect']],
    [UiEvent.RESULT_ADDRESS_BOOK_EDIT_BUTTON, ['ctm.addredit', 'ctm.addredit']],
    [UiEvent.RESULT_ADDRESS_BOOK_REGISTER_BUTTON, ['ctm.addrsave', 'ctm.addrsave']],
    [UiEvent.RESULT_ADDRESS_BOOK_DELETE_BUTTON, ['ctm.addrdelete', 'ctm.addrdelete']],
    [UiEvent.RESULT_ADDRESS_BOOK_SHOW_ALL_BUTTON, ['ctm.addrmore', 'ctm.addrmore']],
    [UiEvent.RESULT_ADDRESS_BOOK_CONFIRM_BUTTON, ['ctm.addrdone', 'ctm.addrdone']],
    [UiEvent.RESULT_ADDRESS_FORM_RECEIVER, ['ctm.addrname', 'ctm.addrname']],
    [UiEvent.RESULT_ADDRESS_FORM_PHONE_NUMBER, ['ctm.addrphone', 'ctm.addrphone']],
    [UiEvent.RESULT_ADDRESS_FORM_ADDITIONAL_PHONE_NUMBER, ['ctm.addrphoneadd', 'ctm.addrphoneadd']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_HOME, ['ctm.addrpresethome', 'ctm.addrpresethome']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_OFFICE, ['ctm.addrpresetoffice', 'ctm.addrpresetoffice']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_SCHOOL, ['ctm.addrpresetschool', 'ctm.addrpresetschool']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_FRIEND, ['ctm.addrpresetfriend', 'ctm.addrpresetfriend']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_FAMILY, ['ctm.addrpresetfamily', 'ctm.addrpresetfamily']],
    [UiEvent.RESULT_ADDRESS_FORM_PRESET_MANUAL, ['ctm.addrpresetmanual', 'ctm.addrpresetmanual']],
    [UiEvent.RESULT_ADDRESS_FORM_SEARCH_ADDRESS, ['ctm.addrdelsearch', 'ctm.addrdelsearch']],
    [UiEvent.RESULT_ADDRESS_FORM_DETAIL_ADDRESS, ['ctm.addrdetail', 'ctm.addrdetail']],
    [UiEvent.RESULT_ADDRESS_FORM_SET_AS_PRIMARY_CHECKBOX, ['ctm.addrdefaultset', 'ctm.addrdefaultset']],
    [UiEvent.RESULT_ADDRESS_FORM_CONFIRM, ['ctm.addrcheck', 'ctm.addrcheck']],
    [UiEvent.RESULT_VIRTUAL_PHONE_NUMBER_CHECKBOX, ['ctm.safe', 'ctm.safe']],
    [UiEvent.RESULT_VIRTUAL_PHONE_NUMBER_INFO, ['ctm.safeinfo', 'ctm.safeinfo']],
    [UiEvent.RESULT_DELIVERY_MEMO_SELECT, ['ctm.click', 'ctm.click']],
    [UiEvent.RESULT_DELIVERY_MEMO_TEXTAREA, ['ctm.delmemo', 'ctm.delmemo']],
    [UiEvent.RESULT_DELIVERY_MEMO_REUSE_CHECKBOX, ['ctm.memosave', 'ctm.memosave']],
    /** 우편번호 검색 */
    [UiEvent.RESULT_ZIP_CODE_SEARCH_BUTTON, ['ctm.zipsearch', 'ctm.zipsearch']],
    [UiEvent.RESULT_ZIP_CODE_RESULT, ['ctm.zipselect', 'ctm.zipselect']],
    [UiEvent.RESULT_ZIP_CODE_RESULT_PAGINATION, ['ctm.zippage', 'ctm.zippage']],
    [UiEvent.DELIVERY_MEMO_DETAIL, ['ctm.seedelmemo', 'ctm.seedelmemo']],
    [UiEvent.ADDRESS_DELETE_CONFIRM_BUTTON, ['ode.addrchkdelete', 'ord.addrchkdelete']],
    [UiEvent.DELIVERY_VIRTUAL_PHONE_NUMBER_INFO_CLOSE_BUTTON, ['ode.safeclose', 'ord.safeclose']],
    [UiEvent.NO_CERTIFICATION_BANNER_TYPE_A, ['ctm.rightawayimgbanner', 'ctm.rightawayimgbanner']],
    [UiEvent.NO_CERTIFICATION_BANNER_TYPE_B, ['ctm.rightawaytextbanner', 'ctm.rightawaytextbanner']],
    /** 배너 */
    [UiEvent.MEMBERSHIP_GUIDE, ['ctm.membershipbanner3', 'ctm.membershipbanner3']],
    [UiEvent.MEMBERSHIP_ANNUAL_GUIDE, ['ctm.membershipbanner2', 'ctm.membershipbanner2']],
    [UiEvent.MEMBERSHIP_PROMOTION_GUIDE, ['ctm.membershipbanner1', 'ctm.membershipbanner1']],
    // 패밀리결제 유도 배너 멤버용
    [UiEvent.FAMILY_PAY_MEMBER, ['ctm.familypayformember', 'ctm.familypayformember']],
    // 패밀리결제 유도 배너 대표용
    [UiEvent.FAMILY_PAY_ORGANIZER, ['ctm.familypayfororganizer', 'ctm.familypayfororganizer']],
    // 패밀리결제 다시 알려주기
    [UiEvent.FAMILY_PAY_REQUEST, ['ctm.familypayrequest', 'ctm.familypayrequest']],
    // 공유하기_카톡
    [UiEvent.FAMILY_PAY_SHARE_KAKAO_TALK, ['ctm.fpsharekakaotalk', 'ctm.fpsharekakaotalk']],
    // 공유하기_문자
    [UiEvent.FAMILY_PAY_SHARE_SMS, ['ctm.fpsharesms', 'ctm.fpsharesms']],
    // 공유하기_톡톡
    [UiEvent.FAMILY_PAY_SHARE_TALK_TALK, ['ctm.fpsharetalktalk', 'ctm.fpsharetalktalk']],
    // 공유하기_닫기
    [UiEvent.FAMILY_PAY_SHARE_CLOSE, ['ctm.fpshareclose', 'ctm.fpshareclose']],
    // 공유하기_보내기
    [UiEvent.FAMILY_PAY_SHARE_CONFIRM, ['ctm.fpshareconfirm', 'ctm.fpshareconfirm']],
])
